module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone.34540dc2.svg";